import { ProductWarranty } from "@interfaces/dto/product-detail.dto";

interface Props {
  warranties: ProductWarranty[];
}

const WarrantyInfo = ({ warranties }: Props) => {
  return (
    <ul className="list-text-red">
      {warranties.map(({ text }, key) => {
        return key == 0 ? (
          <li key={key}>
            <p>{text}</p>
          </li>
        ) : (
          <li className="mx-2" key={key}>
            <p>{text}</p>
          </li>
        );
      })}
    </ul>
  );
};

export default WarrantyInfo;
